<template>
  <v-app class="grey lighten-5">
    <v-container>
      <v-row class="justify-center">
        <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
          <p>Carregando...</p>
          <v-progress-circular
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-circular>
        </div>
        <v-col class="col-12 col-md-10" v-else>
          <div class="d-flex flex-column flex-md-row align-center justify-space-between">
            <h2 class="text-center text-md-left primary--text ml-md-4">
              <v-icon class="primary--text mr-2">calendar_today</v-icon>Detalhe da Consulta
            </h2>
            <div>
              <v-btn
                :to="{name: 'ViewInterviewPatient', params: {id: details.patient.id}}"
                color="success"
                v-if="loggedUser.is_chief_therapist && details.patient.patient_questions"
              >
                Ver Formulário
              </v-btn>
              <v-btn
                class="ml-3 px-5"
                @click="notifyPsychologist()"
                target="_blank"
                color="primary"
                v-if="details.status == 'SCHEDULED' && details.dateTime <= nowDateTime"
              >
                <v-icon class="white--text mr-2">videocam</v-icon>
                Consulta
              </v-btn>
            </div>
            <div class="d-inline-block pa-3 rounded-lg gray white--text" v-if="loggedUser.is_chief_therapist && !details.patient.patient_questions">
              O paciente não preencheu o formulário
            </div>
          </div>
          <p
            v-if="details.status == 'SCHEDULED' && details.dateTime >= nowDateTime"
            class="col-12 ml-md-2 gray--text"
          >O botão para a consulta estará disponível na data e horário da consulta marcada.</p>
          <v-dialog v-model="dialog" max-width="550" class="dialog-consult" v-if="modalFinancial">
            <v-card class="dialog-consult">
              <h1>Informações de Pagamento</h1>
              <section>
                <div>
                  <strong>Nome</strong>
                  <span>{{ details.patient.name.toString() }}</span>
                </div>
                <div>
                  <strong>Valor Cobrado</strong>
                  <span>{{ finalValue | currency }}</span>
                </div>
                <div>
                  <strong>Data</strong>
                  <span>{{ details.date | formatDate }}</span>
                </div>
                <div>
                  <strong>Valor Líquido</strong>
                  <span style="color: #45A655; font-weight: 600;">€ {{ details.stripe_payment_value }}</span>
                </div>
              </section>
              <footer>
                <button @click="offDialog()">Cancelar</button>
                <button @click="goFinances()">Ir para a Receita</button>
              </footer>
            </v-card>
          </v-dialog>
          <div class="row justify-center">
            <div class="col-12 col-md-5">
              <div
                class="box-item custom-radius bg-yellow d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">record_voice_over</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{details.patient.name}}</p>
                </div>
                <v-btn class="bt-perfil" @click="goProfilePatients(details.patient.id)">Ver Perfil</v-btn>
              </div>
              <div
                class="box-item border-bottom d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">calendar_today</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.date | formatDate }}</p>
                </div>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">access_time</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.time | formatDateTZ(details.date, details.time) }}</p>
                </div>
              </div>
              <!--
              <div class="box-item border-bottom px-3 py-4">
                <p class="ma-0 gray--text text-center obs-text">
                  <strong>Obs:</strong> Esse paciente contratou mais 11 consultas com você.
                </p>
              </div>
              -->
          <div v-if="details.coupon_value" class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
              >
              <h3 class="ma-0  gray--text mr-1">Valores</h3>
              <div class="value_cupom d-flex flex-row align-center" style="margin-left: 20px;">
              <img :src="require('../../assets/cashBag.svg')" width="28px" />
                <div style="margin-left: 20px;">
                  <p class="ma-0  gray--text mr-1">Valor:<span class="ma-0 secondary--text ">{{value}}</span></p>
                  <p class="ma-0  gray--text mr-1">{{ $t('queryDetail.coupon') }} ({{details.coupon_value}}%):<span class="ma-0 secondary--text "> -€ {{discountValue}}</span>  </p>
                </div>
              </div>
              </div>
              <div
                @click="onDialog()"
                v-if="details.status == 'CLOSED'"
                style="cursor: pointer; padding: 0px 10px 0px 30px; overflow: hidden;"
                class="box-item bg-gray d-flex flex-row align-center justify-space-between mt-3 custom-radius"
              >

                <div class="d-flex align-center" style="padding: 10px 0px 10px 0px;">
                  <p class="ma-0 mr-1 gray--text">
                    <strong>Valor da Consulta:</strong>
                  </p>
                  <p class="ma-0 secondary--text valor-consulta">{{ finalValue || currency}}</p>
                </div>
                <div style="border-left: 2px solid #c4bebe; padding-left: 15px; height: 50px; padding: 0px 11px 0px 18px;" class="d-flex align-center justify-end">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="30.705" viewBox="0 0 31.503 30.705">
                    <path id="Icon_awesome-arrow-right" data-name="Icon awesome-arrow-right" d="M13.395,4.7l1.561-1.561a1.681,1.681,0,0,1,2.384,0L31.008,16.8a1.681,1.681,0,0,1,0,2.384L17.339,32.857a1.681,1.681,0,0,1-2.384,0L13.395,31.3a1.689,1.689,0,0,1,.028-2.412L21.9,20.813H1.688A1.683,1.683,0,0,1,0,19.125v-2.25a1.683,1.683,0,0,1,1.688-1.687H21.9L13.423,7.116A1.677,1.677,0,0,1,13.395,4.7Z" transform="translate(0 -2.647)" fill="#93291e"/>
                  </svg>
                </div>
              </div>
              <div
                v-else
                class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
              >
                <p class="ma-0 mr-2 gray--text">
                  <strong>Valor da Consulta:</strong>
                </p>
                <p class="ma-0 mr-2 secondary--text valor-consulta">{{finalValue || currency}}</p>
              </div>
              <div
                class="bg-yellow font-weight-medium f-12 custom-radius justify-center d-flex text-center mt-2 py-3"
                v-if="statusPayment"
              >
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-if="statusPayment === 'APPROVED' && paymentType === 'pix'"
                >
                  <span class="secondary--text">✅ Pago via PIX</span>
                </p>
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-else-if="statusPayment === 'APPROVED'"
                >
                  Status de pagamento: <strong class="secondary--text">Aprovado</strong>
                </p>
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-if="statusPayment === 'PENDING' && paymentType === 'pix'"
                >
                  <strong class="gray--text">⏳ Aguardando pagamento (PIX)</strong>
                </p>
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-else-if="statusPayment === 'PENDING'"
                >
                  Status de pagamento: <strong class="gray--text">Pendente</strong>
                </p>
                <p
                  class="ma-0 gray--text text-center font-weight-medium"
                  v-if="statusPayment === 'FAILED'"
                >
                  Status de pagamento: <span class="error--text">❌ Cancelado</span>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <p class="ma-0 mr-2 gray--text text-center text-md-left">
                <strong>Contatos</strong>
              </p>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-between px-3 py-4"
                v-if="details.patient.telephone"
              >
                <p class="ma-0 gray--text">
                  <strong class="d-flex flex-row align-center justify-center">
                    <span class="mr-3">Telefone</span>
                  </strong>
                </p>
                <p class="ma-0 mr-2 gray--text text-right">
                  <div class="d-flex flex-row align-center justify-start w-100">
                    <v-icon class="secondary--text mr-3">local_phone</v-icon>
                    <!-- <div class="whats-img mx-2">
                      <v-img :src="require('../../assets/logo-whatsapp.svg')" width="32px"></v-img>
                    </div> -->
                    <strong class="gray--text">{{details.patient.telephone}}</strong>
                  </div>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-between px-3 py-4 mt-3"
                v-if="details.patient.whatsapp"
              >
                <p class="ma-0 gray--text">
                  <strong class="d-flex flex-row align-center justify-center">
                    <span class="mr-1">Whatsapp</span>
                  </strong>
                </p>
                <p class="ma-0 mr-2 gray--text text-right">
                  <div class="d-flex flex-row align-center justify-start w-100">
                    <div class="whats-img mr-2">
                      <v-img :src="require('../../assets/logo-whatsapp.svg')" width="32px"></v-img>
                    </div>
                    <strong class="gray--text">{{details.patient.whatsapp}}</strong>
                  </div>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
                v-if="details.patient.skype"
              >
                <p class="ma-0 gray--text">
                  <strong>Skype</strong>
                </p>
                <div class="skype-img ml-2">
                  <v-img :src="require('../../assets/logo-skype.svg')" width="32px"></v-img>
                </div>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.skype}}</strong>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
              >
                <p class="ma-0 gray--text">
                  <strong>Email</strong>
                </p>
                <v-icon class="gray--text ml-2" size="30">email</v-icon>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.email}}</strong>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
                v-if="details.patient.hangouts"
              >
                <p class="ma-0 gray--text">
                  <strong>Hangout</strong>
                </p>
                <div class="skype-img ml-2">
                  <v-img :src="require('../../assets/icon-hangout.svg')" width="32px"></v-img>
                </div>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.hangouts}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-center">
            <div class="col-12 col-md-3 text-center" v-if="details.status == 'SCHEDULED' && details.date > date">
              <v-row justify="center">
              <v-dialog v-model="dialog" max-width="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" v-on="on" class="white--text" height="50" min-width="100%">Cancelar</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline">Cancelar consulta!</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        <p>Informe aqui o motivo do cancelamento.</p>
                        <v-textarea solo flat no-resize background-color="#F7F7F7" rows="8" v-model="justification"></v-textarea>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                      <v-btn color="primary darken-1" text :disabled="isDisabled" @click="cancelConsultation()">Ok</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
            <div class="col-12 col-md-3 text-center" v-if="details.status == 'SCHEDULED' && details.dateTime <= nowDateTime && !(paymentType === 'pix' && statusPayment === 'PENDING') && statusPayment !== 'FAILED'">
              <v-btn
                :to="{ name: 'FormProntuario', params: { maker: true,  idAppointment: details.id , idMedicalRecord: 'created'}   } "
                :loading="isLoading"
                :disabled="isLoading"
                color="primary"
                height="50"
                min-width="100%"
                @click="doneConsultation"
              >Finalizar</v-btn>
            </div>
            <div class="col-12 col-md-3 text-center" v-if="details.status == 'CLOSED' && !details.medical_record">
              <v-btn color="primary" height="50" min-width="100%"  :to="{ name: 'FormProntuario', params: { maker: true,  idAppointment: details.id , idMedicalRecord: 'created'}   } ">Aplicar Prontuário</v-btn>
            </div>
          </div>
          <v-row justify="center">
            <v-col
                class="col-12 col-md-4 text-center"
                v-if="details.status == 'CANCELLED'"
              >
              <div class="grey white--text px-4 py-3">
                <p class="ma-0 font-weight-bold">
                  Consulta cancelada.
                </p>
                <p class="ma-0 mt-3 text-left">
                  Motivo: {{details.closing.comments}}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { getDetails, getProfile } from '../../services/psychologists';

import Api from '../../services/httpClient';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: new Date().toTimeString().substr(0, 8),
      nowDateTime: new Date().toISOString().substr(0, 19),
      cod: '',
      details: {
        date: String,
        id: String,
        patient: {},
        psychologist_name: String,
        stripe_payment_value: String,
        total_stripe_payment_value: String,
        psychologist: Number,
        status: String,
        time: String,
        typePayment: String,
      },
      statusPayment: '',
      paymentType: '',
      value: '',
      justification: '',
      dialog: false,
      isDisabled: true,
      isLoading: true,
      loggedUser: {},
      finalValue: '',
      discountValue: '',
      modalFinancial: false,
    };
  },
  async created() {
    this.getCod();
    await this.loadDetails();
    this.getValue();
    await this.pegaPerfil();
  },
  watch: {
    justification(val) {
      val ? (this.isDisabled = false) : (this.isDisabled = true);
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    onDialog() {
      this.dialog = true;
    },
    offDialog() {
      this.dialog = false;
    },
    goFinances() {
      this.$router.replace('/psicologo/financeiro');
    },
    async pegaPerfil() {
      const res = await getProfile(this.cod);
      this.loggedUser = res;
    },
    async loadDetails() {
      const { id } = await this.$route.params;
      try {
        const { data } = await getDetails(this.cod, id);
        this.statusPayment = data.status_payment;
        this.paymentType = data.payment_method_type;
        this.details = data;
        this.details.dateTime = data.date.concat('T', data.time);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    goProfilePatients(id) {
      this.$router.push({ name: 'PacienteProfile', params: { id } });
    },
    notifyPsychologist() {
      // Não aguarda a notificação: se o envio do e-mail demorar ou falhar,
      // o psicólogo precisa conseguir abrir o vídeo mesmo assim.
      Api.post(`/notify_psychologist/`, {
        appointmentId: this.details.id,
      }).catch((error) => console.log(error));
      this.$router.replace(
        `/psicologo/meeting/${this.details.id}/ondivan-${this.details.psychologist}-${this.details.patient.id}`,
      );
    },
    doneConsultation() {
      this.modalFinancial = true;
      this.isLoading = true;
      const { id } = this.$route.params;
      Api.post(
        `/psychologists/${this.cod}/appointments/${id}/closing/`,
        {},
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          const { data, status } = response;
          if (status === 200) {
            this.details = data;
            this.$router.replace({
              name: 'FormProntuario',
              params: { idAppointment: id },
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async getValue() {
      const user = await JSON.parse(localStorage.getItem('user-data'));
      this.value =
        user.appointment_pt_value !== '0.00'
          ? ` ${user.appointment_pt_value}`
          : `R$ ${user.appointment_br_value}`;
      if (this.details.coupon_value) {
        this.finalValue = this.value.split(' ');
        this.discountValue =
          this.finalValue[1] * (this.details.coupon_value / 100);
        this.finalValue = `${this.finalValue[0]} ${
          this.finalValue[1] - this.discountValue
        }`;
      } else {
        this.finalValue = this.value;
      }
    },
    cancelConsultation() {
      Api.post(
        `/psychologists/${this.cod}/appointments/${this.details.id}/cancellation/`,
        {
          comments: this.justification,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          const { data, status } = response;
          if (status === 200) {
            this.details = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.value_cupom {
  line-height: 1.2;
}
.value_cupom p {
  margin: 0;
}
.box-item {
  width: 100%;
}

.custom-radius {
  border-radius: 5px;
}

.bg-yellow {
  background-color: #fffde3;
}

.bg-gray {
  background-color: #e0e0e0 !important;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.bt-perfil {
  font-size: 0.5rem;
}

.obs-text {
  font-size: 0.8rem;
}

.valor-consulta {
  font-size: 1.3rem;
}

.whats-img,
.whats-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.skype-img,
.skype-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.email-img,
.email-img .v-image__image--cover {
  width: 30px;
  height: 30px;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.dialog-consult {
  padding: 40px 20px;
  background: #ededed;
}
.dialog-consult strong {
  color: #6f6f6f;
}
.dialog-consult span {
  color: #635e5e;
  margin-top: 5px;
}
.dialog-consult section {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 70px;
}

.dialog-consult footer {
  margin-top: 35px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.dialog-consult button {
  padding: 4px 8px;
  border-radius: 5px;
  font-weight: 600;
}

.dialog-consult button:first-child {
  background: transparent;
  color: #635e5e;
  border: 2px solid #635e5e;
}
.dialog-consult button:last-child {
  background: #45a655;
  color: #fff;
}
.dialog-consult h1 {
  color: #45a655;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}

.dialog-consult div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 20px;
}
@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
